import { jsx as _jsx } from "react/jsx-runtime";
import anchorme from 'anchorme';
import DOMPurification from 'dompurify';
import { useCallback, memo } from 'react';
export const phoneNumberRegex = /\b(0030|\+30)?(210\d{7}|69\d{8})\b|\b1?-?\(?[0-9]{3}[\-\)][0-9]{3}-[0-9]{4}\b/gi;
export const Linkify = memo(({ children: message }) => {
    const sanitizer = DOMPurification.sanitize;
    const formatMessage = useCallback(() => anchorme({
        input: message,
        options: {
            // Fixes Moveo.ai wrong url
            specialTransform: [
                {
                    test: /\bveo\.ai\b/i,
                    transform: (s) => s,
                },
            ],
            attributes: { target: '_blank', rel: 'noopener noreferrer' },
        },
        extensions: [
            // an extension for greek + usa phones
            {
                test: phoneNumberRegex,
                transform: (string) => `<a href="tel:${string}">${string}</a>`,
            },
        ],
    }), [message]);
    return (_jsx("span", { dangerouslySetInnerHTML: {
            __html: sanitizer(formatMessage()),
        } }));
});
Linkify.displayName = 'Linkify';
